module.exports = __webpack_public_path__ + "img/grey_049.d63f0b69.png";